import { combineReducers } from 'redux';
import appointmentReducer from './appointmentForm.reducer';
import navMenuReducer from './navMenu.reducer';
import notificationsReducer from './notifications.reducer';
import prescriptionProfileReducer from './prescriptionProfile.reducer';
import sessionReducer from './session.reducer';

const rootReducer = combineReducers({
  session: sessionReducer,
  navMenu: navMenuReducer,
  appointmentForm: appointmentReducer,
  prescriptionProfile: prescriptionProfileReducer,
  notification: notificationsReducer,
});

export type GlobalState = ReturnType<typeof rootReducer>;

export default rootReducer;
